import {
  OlxImportListingSearch,
  OlxImportManagementFields,
  OlxImportManagementFilters,
  OlxImportManagementListingItem,
  Pagination,
} from 'common/types';
import {apiMethod, APIService} from 'services/APIService';

export interface SmallOlxImportListing {
  pagination: Pagination;
  fields: OlxImportManagementFields;
  filters: OlxImportManagementFilters;
  items: OlxImportManagementListingItem[];
  sort: string;
}

export class OlxImportAPI extends APIService {
  fetchOlxImportList = apiMethod<SmallOlxImportListing>(
    (params: Partial<OlxImportListingSearch>) =>
    this.fetcher.request({
      method: 'get',
      url: '/api/olx-import/list/',
      params,
    }),
  );

  importDraft = apiMethod(
    (id: number) =>
      this.fetcher.request({
        method: 'put',
        url: `/api/olx-import/import/${id}/`,
      })
  );

}
